import { render, staticRenderFns } from "./TotalSpend.vue?vue&type=template&id=c3280cb2&"
import script from "./TotalSpend.vue?vue&type=script&lang=js&"
export * from "./TotalSpend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports